// extracted by mini-css-extract-plugin
module.exports = {"search":"map-search-box_search__CRufo","searchbox":"map-search-box_searchbox__2aKK3","filterBtn":"map-search-box_filterBtn__2lJ_R"};